module.exports = __webpack_public_path__ + "static/media/106-cameroon.fe9d8230.svg";